import { useEffect, useRef, useState } from "react";

import { cn } from "@/utils";
import { useTranslate } from "@/providers/context";

export const OfferDescription = ({ Description }: { Description: string }) => {
  const { translate } = useTranslate();

  const descRef = useRef<HTMLDivElement>(null);

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const checkContentHeight = () => {
      const currentHeight = descRef.current?.clientHeight ?? 0;
      // Check if the content height exceeds 44px
      setIsOverflowing(currentHeight > 44);
    };

    checkContentHeight();

    window.addEventListener("resize", checkContentHeight);
    return () => window.removeEventListener("resize", checkContentHeight);
  }, [descRef, Description]);

  return (
    <div className="relative">
      <div
        ref={descRef}
        className={cn(
          "p2-medium text-item-secondary mb-4 max-h-[45px] overflow-clip",
          isExpanded && "!max-h-none pb-5",
        )}
      >
        {Description}
      </div>
      {isOverflowing && (
        <div
          className="p2-bold text-item-secondary absolute bottom-0 right-0 flex cursor-pointer"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className="to-bg-surface-primary w-5 bg-gradient-to-r from-transparent" />
          <div className="bg-surface-primary pl-2">
            {translate(isExpanded ? "Read Less" : "Read More")}
          </div>
        </div>
      )}
    </div>
  );
};
